import { Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React, { FunctionComponent } from "react";
import { Colors } from "../../style/Colors";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const logoWidth = 210;

const useStyles = makeStyles()((theme) => ({
  platformContainer: {
    background: Colors.grayLight,
    cursor: "pointer",
    padding: 20,
    borderRadius: 4,
    border: "1px solid #ffffff",
    position: "relative",
  },
  textContainer: {
    width: `calc(100% - ${logoWidth}px)`,
  },
  subTitle: {
    color: Colors.red,
  },
  title: {},
  logo: {
    width: logoWidth,
    [theme.breakpoints.up("sm")]: {
      textAlign: "center",
    },
  },
  externalLinkIcon: {
    position: "absolute",
    top: 12,
    right: 12,
  },
}));

interface IPlatformContainerTitleProps {
  handleSelection: () => void;
  Logo: FunctionComponent;
  title: string;
  subTitle?: string;
  showExternalLinkIcon?: boolean;
}

export const PlatformContainerTitle: React.VFC<IPlatformContainerTitleProps> = (props) => {
  const { handleSelection, Logo, title, subTitle, showExternalLinkIcon } = props;
  const { classes } = useStyles();

  return (
    <Grid container direction="row" className={classes.platformContainer} onClick={handleSelection}>
      <Grid item id="platform-logo" className={classes.logo}>
        <Logo />
      </Grid>
      <Grid
        xs={12}
        sm="auto"
        item
        id="platform-title"
        className={classes.textContainer}
        container
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <Typography variant="h5" className={classes.title}>
            {title}
          </Typography>
        </Grid>
        {subTitle && (
          <Grid item xs={12}>
            <Typography variant="body1" className={classes.subTitle}>
              {subTitle}
            </Typography>
          </Grid>
        )}
      </Grid>
      {showExternalLinkIcon && (
        <Grid item className={classes.externalLinkIcon}>
          <OpenInNewIcon sx={{ color: Colors.greenLight, width: 20, height: 20 }} />
        </Grid>
      )}
    </Grid>
  );
};
